// extracted by mini-css-extract-plugin
module.exports = {"trafficRulesWrapper":"_3s1Wt","rulesText":"_3Mf5X","readMore":"_1X7f8","trafficRulesWrapperDesktop":"_3OXf2","rulesList":"_rVjQ","rulesListOpen":"vkXgK"};